import React from 'react';
import FotoUpload from './FotoUpload';

// Galeria de até `max` fotos com adicionar/remover (compacta ao remover).
// Reaproveitada em 3 lugares: fotos do componente (Diagnóstico), "Outros" do
// registro ANTES (Diagnóstico) e "Outros" do registro DEPOIS (Certificação).
//
// Props:
//  - fotos: array de URLs (fonte da verdade fica no pai)
//  - onChange(novaLista): recebe a lista já atualizada
//  - max: teto de fotos (default 3)
//  - prefixoSlot: base do nome do slot/arquivo (ex.: nome do componente)
//  - placeholderVazio: texto quando não há foto; passe null p/ não mostrar nada
//    (ex.: no componente, a obrigatoriedade é avisada por fora).
const FotosOutros = ({ fotos, onChange, max = 3, patrimonio, chave, prefixoSlot, placeholderVazio = 'nenhuma (opcional)' }) => {
  const lista = (fotos || []).filter(Boolean);

  const setAt = (idx, url) => {
    let nova = [...lista];
    if (url) nova[idx] = url;          // troca a foto daquela posição
    else nova = nova.filter((_, i) => i !== idx); // remover → compacta a lista
    onChange(nova);
  };
  const add = (url) => { if (url && lista.length < max) onChange([...lista, url]); };

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end' }}>
      {lista.map((u, i) => (
        <FotoUpload key={i} url={u} onUrl={(nu) => setAt(i, nu)}
          patrimonio={patrimonio} chave={chave} slot={`${prefixoSlot} ${i + 1}`} />
      ))}
      {/* Slot vazio de adicionar — só até atingir o máximo. A `key` muda com o
          tamanho da lista pra remontar (e zerar) o seletor após cada adição. */}
      {lista.length < max && (
        <FotoUpload key={`add-${lista.length}`} url={''} label="+ Foto"
          onUrl={add} patrimonio={patrimonio} chave={chave} slot={`${prefixoSlot} ${lista.length + 1}`} />
      )}
      {lista.length === 0 && placeholderVazio && (
        <span style={{ fontSize: 12, color: '#94a3b8' }}>{placeholderVazio}</span>
      )}
    </div>
  );
};

export default FotosOutros;
